/**
 * 底部导航栏组件
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './TabBar.css';

const TABS = [
  { key: 'games', path: '/games', icon: '🎮', label: '游戏管理' },
  { key: 'profile', path: '/profile', icon: '👤', label: '我的' },
];

const TabBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path) => pathname === path || (path === '/games' && pathname.startsWith('/device/'));

  return (
    <nav className="tab-bar">
      {TABS.map(({ key, path, icon, label }) => (
        <div
          key={key}
          className={`tab-item ${isActive(path) ? 'active' : ''}`}
          onClick={() => navigate(path)}
        >
          <span className="tab-icon">{icon}</span>
          <span className="tab-label">{label}</span>
        </div>
      ))}
    </nav>
  );
};

export default TabBar;
